import React from 'react';
import { NavLink } from 'react-router-dom';
import { getLanguageSection } from '../shared/services/languageService';

const Error = () => {
  const language = getLanguageSection('page404');

  return (
    <div id="error-page" className="mr-ui bg-[#f3f5fb] px-4 py-10 md:px-8">
      <div className="mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-marival md:p-10">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-600">
          <svg className="h-8 w-8" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 9v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            <path d="M12 17h.01" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
            <path d="M10.3 4.8 2.9 18a1.5 1.5 0 0 0 1.3 2.2h15.6a1.5 1.5 0 0 0 1.3-2.2L13.7 4.8a2 2 0 0 0-3.4 0Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          </svg>
        </div>

        <p className="m-0 text-sm font-black uppercase text-[#f5660b]">ERROR 404</p>
        <h1 className="m-0 mt-3 text-3xl font-black leading-tight text-[#11183f] md:text-4xl">
          Page not found
        </h1>
        <p className="mx-auto mb-7 mt-4 max-w-xl text-base leading-7 text-slate-600">
          {language.text}
        </p>

        <NavLink
          className="inline-flex h-12 w-full max-w-sm items-center justify-center rounded-xl bg-[#f6c833] text-sm font-black text-[#11183f] shadow-[0_12px_24px_rgba(246,200,51,0.26)] hover:bg-[#ffd84d]"
          to="/"
        >
          {language.welcome}
        </NavLink>
      </div>
    </div>
  );
};

export default Error;
